import {create} from 'zustand';
import {
    generateExpertsWithLLM
} from '../features/products/reportEditorPage/leftPanel/components/findExpert/generateExpertsWithLLM';

/**
 * Zustand store for managing expert suggestions state
 *
 * State:
 * - instructions: string - current search instructions
 * - experts: array - generated expert profiles
 * - loading: boolean - whether generation is in progress
 * - error: string | null - error message if generation failed
 *
 * Actions:
 * - setInstructions(instructions) - update instructions without generating
 * - generateExperts(instructions?) - generate experts (uses current instructions if not provided)
 * - reset() - reset to initial state
 */
const useExpertStore = create((set, get) => ({
    // State
    instructions: '',
    experts: [],
    loading: false,
    error: null,

    // Actions
    setInstructions: (instructions) => {
        set({instructions: instructions || ''});
    },

    generateExperts: async (instructionsOverride) => {
        const {loading} = get();

        // Prevent duplicate calls while loading
        if (loading) return;

        const instructions = instructionsOverride ?? get().instructions;

        set({
            loading: true,
            error: null,
            experts: [],
        });

        try {
            console.log('Generating experts with instructions:', instructions);
            const generatedExperts = await generateExpertsWithLLM(instructions);
            console.log('Experts generated:', generatedExperts);

            set({
                experts: generatedExperts,
                loading: false,
            });

            return generatedExperts;
        } catch (error) {
            console.error('Error generating experts:', error);
            set({
                error: error.message || 'Failed to generate experts',
                loading: false,
            });
            return [];
        }
    },

    // Set instructions and immediately trigger generation (for floating menu)
    setInstructionsAndGenerate: async (instructions) => {
        set({instructions: instructions || ''});
        return get().generateExperts(instructions);
    },

    reset: () => {
        set({
            instructions: '',
            experts: [],
            loading: false,
            error: null,
        });
    },
}));

export default useExpertStore;
